/*!
 * HI Pop-up v1.4.0 - homeidealist.com (Dawn 15.1.0)
 * assets/hi-popup.js - loaded (async) by snippets/hi-popup.liquid only when at least one
 * "Popup campaign" metaobject entry is Live or Test (Basics: Status; old Active field as fallback). Vanilla JS, no dependencies, no external requests
 * (Poppins is served from the store's own /cdn/fonts/ path). Everything is wrapped in try/catch so
 * a problem here can never break the page, the cart drawer or product forms.
 */
(function (window, document) {
  'use strict';

  var VERSION = '1.4.0';
  var LS_PREFIX = 'hi_popup:';          // localStorage, one key per campaign code
  var SS_PARAMS = 'hi_popup_params';    // sessionStorage, merged URL params for the visit
  var SS_REF = 'hi_popup_ref';          // sessionStorage, external landing referrer
  var SS_TEST = 'hi_popup_test';        // sessionStorage, ?hi_popup=show|force|CODE for the visit
  var SS_PENDING = 'hi_popup_pending';  // sessionStorage, sign-up handed to the real form submit (page reload)
  var SS_CLOSED = 'hi_popup_closed_session'; // sessionStorage, { CODE: 1 } closed this visit: never opens again on any page of this visit (v1.4.0)
  var SS_TEASER = 'hi_popup_teaser';    // sessionStorage, { CODE: 'on' | 'off' } teaser tab for this visit: 'on' after every close, 'off' once the visitor closes the tab (v1.4.0)
  var SS_FORCED = 'hi_popup_forced';    // sessionStorage, { CODE: 1 } a test link / test mode already forced this code open once this visit (v1.4.0)
  var SS_NOAJAX = 'hi_popup_noajax';    // sessionStorage, "use the page-reload sign-up for this visit" (set after any doubt)
  var SS_SENT = 'hi_popup_sent';        // sessionStorage, { CODE: [emails] } signed up this visit (never POST the same email twice)
  var MOBILE_MQ = '(max-width: 749px)'; // Dawn's breakpoint
  var TZ = 'America/Toronto';
  var DAY = 86400000;

  var DEFAULTS = {
    width: 600, minHeight: 460, padding: 20, radius: 15, border: 0,
    delay: 0, closeDays: 5, submitDays: 365, // delay 0: empty 'Open when' = open immediately (no built-in wait)
    background: '#FFFFFF', headline: '#121212', text: '#121212', button: '#121212',
    buttonText: '#FFFFFF', borderColor: '#121212', overlay: '#141414',
    textSize: 16, consentSize: 12 // text / small-print sizes (px); empty = these (= the v1.1.0 look)
  };
  var SIZE_LIMITS = { textSize: [10, 40], consentSize: [8, 24] }; // same min/max as the field validations (text_size, consent_size)

  var PAGE_TYPES = {
    home: ['index'], index: ['index'], product: ['product'], collection: ['collection', 'list-collections'],
    collections: ['list-collections'], page: ['page'], blog: ['blog'], article: ['article'],
    search: ['search'], cart: ['cart'], '404': ['404']
  };

  /* ------------------------------------------------------------------ i18n (UI strings) */
  var I18N = {
    en: { email: 'Email', first: 'First name', last: 'Last name', days: 'Days', hours: 'Hours', minutes: 'Minutes', seconds: 'Seconds',
      close: 'Close', copy: 'Copy', copied: 'Copied!', skip: 'No thanks', skipQ: 'Skip', submit: 'Sign up', shop: 'Shop now', ok: 'Continue',
      successHeadline: 'Thanks for subscribing!', errEmail: 'Please enter a valid email address.', errRequired: 'Please fill in this field.',
      errGeneric: 'Something went wrong. Please try again.', errConfirm: "We couldn't confirm your sign-up. Please try again.",
      errCheckClosed: 'The security check was closed before it finished. Please try again.', code: 'Your code', dialog: 'Special offer', hideTab: 'Hide',
      consent: 'By signing up you agree to receive marketing emails from HomeIdealist. Unsubscribe anytime.' },
    fr: { email: 'E-mail', first: 'Prénom', last: 'Nom', days: 'Jours', hours: 'Heures', minutes: 'Minutes', seconds: 'Secondes',
      close: 'Fermer', copy: 'Copier', copied: 'Copié !', skip: 'Non merci', skipQ: 'Passer', submit: "S'inscrire", shop: 'Acheter', ok: 'Continuer',
      successHeadline: 'Merci pour votre inscription !', errEmail: 'Veuillez saisir une adresse e-mail valide.', errRequired: 'Veuillez remplir ce champ.',
      errGeneric: 'Une erreur est survenue. Veuillez réessayer.', errConfirm: "Nous n'avons pas pu confirmer votre inscription. Veuillez réessayer.",
      errCheckClosed: "La vérification de sécurité a été fermée avant la fin. Veuillez réessayer.", code: 'Votre code', dialog: 'Offre spéciale', hideTab: 'Masquer',
      consent: "En vous inscrivant, vous acceptez de recevoir des e-mails marketing de HomeIdealist. Désinscription possible à tout moment." },
    de: { email: 'E-Mail', first: 'Vorname', last: 'Nachname', days: 'Tage', hours: 'Stunden', minutes: 'Minuten', seconds: 'Sekunden',
      close: 'Schließen', copy: 'Kopieren', copied: 'Kopiert!', skip: 'Nein, danke', skipQ: 'Überspringen', submit: 'Anmelden', shop: 'Jetzt shoppen', ok: 'Weiter',
      successHeadline: 'Danke für deine Anmeldung!', errEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.', errRequired: 'Bitte fülle dieses Feld aus.',
      errGeneric: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.', errConfirm: 'Wir konnten deine Anmeldung nicht bestätigen. Bitte versuche es erneut.',
      errCheckClosed: 'Die Sicherheitsprüfung wurde vor dem Abschluss geschlossen. Bitte versuche es erneut.', code: 'Dein Code', dialog: 'Sonderangebot', hideTab: 'Ausblenden',
      consent: 'Mit der Anmeldung stimmst du zu, Marketing-E-Mails von HomeIdealist zu erhalten. Abmeldung jederzeit möglich.' },
    it: { email: 'Email', first: 'Nome', last: 'Cognome', days: 'Giorni', hours: 'Ore', minutes: 'Minuti', seconds: 'Secondi',
      close: 'Chiudi', copy: 'Copia', copied: 'Copiato!', skip: 'No, grazie', skipQ: 'Salta', submit: 'Iscriviti', shop: 'Acquista ora', ok: 'Continua',
      successHeadline: 'Grazie per esserti iscritto!', errEmail: 'Inserisci un indirizzo email valido.', errRequired: 'Compila questo campo.',
      errGeneric: 'Si è verificato un errore. Riprova.', errConfirm: 'Non siamo riusciti a confermare la tua iscrizione. Riprova.',
      errCheckClosed: 'Il controllo di sicurezza è stato chiuso prima della fine. Riprova.', code: 'Il tuo codice', dialog: 'Offerta speciale', hideTab: 'Nascondi',
      consent: 'Iscrivendoti accetti di ricevere email di marketing da HomeIdealist. Puoi annullare l’iscrizione in qualsiasi momento.' },
    es: { email: 'Correo electrónico', first: 'Nombre', last: 'Apellido', days: 'Días', hours: 'Horas', minutes: 'Minutos', seconds: 'Segundos',
      close: 'Cerrar', copy: 'Copiar', copied: '¡Copiado!', skip: 'No, gracias', skipQ: 'Omitir', submit: 'Suscribirme', shop: 'Comprar ahora', ok: 'Continuar',
      successHeadline: '¡Gracias por suscribirte!', errEmail: 'Introduce un correo electrónico válido.', errRequired: 'Rellena este campo.',
      errGeneric: 'Algo salió mal. Inténtalo de nuevo.', errConfirm: 'No pudimos confirmar tu suscripción. Inténtalo de nuevo.',
      errCheckClosed: 'La verificación de seguridad se cerró antes de terminar. Inténtalo de nuevo.', code: 'Tu código', dialog: 'Oferta especial', hideTab: 'Ocultar',
      consent: 'Al suscribirte aceptas recibir correos de marketing de HomeIdealist. Puedes darte de baja en cualquier momento.' }
  };
  function strings(locale) {
    var l = String(locale || 'en').toLowerCase().split('-')[0];
    var base = I18N.en, loc = I18N[l] || {}, out = {}, k;
    for (k in base) out[k] = loc[k] || base[k];
    return out;
  }

  /* ------------------------------------------------------------------ storage helpers */
  function store(kind) { try { var s = window[kind]; var t = '__hi'; s.setItem(t, t); s.removeItem(t); return s; } catch (e) { return null; } }
  function sGet(s, k) { try { var v = s && s.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function sSet(s, k, v) { try { if (s) s.setItem(k, JSON.stringify(v)); } catch (e) { /* quota / private mode */ } }
  function sDel(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }
  function clearAll(ls, ss) {
    [ls, ss].forEach(function (s) {
      if (!s) return;
      var keys = [];
      for (var i = 0; i < s.length; i++) { var k = s.key(i); if (k && k.indexOf('hi_popup') === 0) keys.push(k); }
      keys.forEach(function (k) { sDel(s, k); });
    });
  }

  /* ------------------------------------------------------------------ small utils */
  function str(v) { return v == null ? '' : String(v); }
  function trim(v) { return str(v).replace(/^\s+|\s+$/g, ''); }
  function lower(v) { return trim(v).toLowerCase(); }
  function splitList(v) { return str(v).split(/[\n,]+/).map(trim).filter(Boolean); }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function codeKey(code) { return trim(code).toUpperCase(); }
  function slugify(v) {
    var s = str(v);
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
  }
  function esc(v) {
    return str(v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  // Same-site links follow the visitor's language: /collections/all -> /fr/collections/all when browsing /fr (routes.root_url).
  function localizeLink(href, root, origin) {
    try {
      root = str(root || '/').replace(/\/$/, '');
      if (!root || !href || /^(mailto|tel|sms):/i.test(href)) return href;
      var u = new URL(href, origin), host = new URL(origin).hostname;
      if (u.hostname !== host && u.hostname.replace(/^www\./, '') !== host.replace(/^www\./, '')) return href;
      if (u.pathname === root || u.pathname.indexOf(root + '/') === 0 || /^\/(cdn|s\/files)\//.test(u.pathname)) return href;
      return u.pathname.replace(/^\//, root + '/') + u.search + u.hash;
    } catch (e) { return href; }
  }
  function cssUrl(u) { return u ? 'url("' + str(u).replace(/["\\\n\r]/g, '') + '")' : 'none'; }
  function isColor(c) { c = trim(c); return /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(c) || /^rgba?\([\d\s.,%]+\)$/i.test(c); }
  function color(c, d) { return isColor(c) ? trim(c) : d; }
  function hexA(hex, a) {
    if (trim(hex).charAt(0) !== '#') return trim(hex);
    var h = trim(hex).replace('#', '');
    if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    var n = parseInt(h.slice(0, 6), 16);
    return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')';
  }

  /* ------------------------------------------------------------------ time / countdown (America/Toronto) */
  // US/Canada Eastern rules (since 2007): DST from 2nd Sunday of March 02:00 local to 1st Sunday of November 02:00 local.
  function nthSunday(y, month, n) { var d = new Date(Date.UTC(y, month, 1)); var first = (7 - d.getUTCDay()) % 7 + 1; return first + (n - 1) * 7; }
  function easternOffsetManual(ms) { // minutes, local - UTC (-240 EDT, -300 EST)
    var y = new Date(ms).getUTCFullYear();
    var start = Date.UTC(y, 2, nthSunday(y, 2, 2), 7);  // 02:00 EST = 07:00 UTC
    var end = Date.UTC(y, 10, nthSunday(y, 10, 1), 6);   // 02:00 EDT = 06:00 UTC
    return (ms >= start && ms < end) ? -240 : -300;
  }
  function tzOffset(ms, tz) {
    tz = tz || TZ;
    try {
      var dtf = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var p = {};
      dtf.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
      var asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
      return Math.round((asUtc - Math.floor(ms / 1000) * 1000) / 60000);
    } catch (e) { return easternOffsetManual(ms); }
  }
  // Wall-clock time in Toronto -> UTC epoch ms (handles EDT/EST automatically).
  function torontoToUtc(y, mo, d, h, mi, s) {
    var guess = Date.UTC(y, mo - 1, d, h || 0, mi || 0, s || 0);
    var off = tzOffset(guess);
    var t = guess - off * 60000;
    var off2 = tzOffset(t);
    if (off2 !== off) t = guess - off2 * 60000;
    return t;
  }
  // Accepts epoch seconds (from Liquid date: '%s'), ISO with offset, or naive "YYYY-MM-DD HH:MM" (= Toronto time).
  function parseTime(v) {
    if (v == null || v === '') return null;
    if (typeof v === 'number' && isFinite(v)) return v < 1e11 ? v * 1000 : v;
    var s = trim(v);
    if (/^\d{9,11}$/.test(s)) return parseInt(s, 10) * 1000;
    var m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?\s*(Z|[+-]\d{2}:?\d{2})?$/i);
    if (!m) { var p = Date.parse(s); return isFinite(p) ? p : null; }
    if (m[7]) {
      var t = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
      if (/z/i.test(m[7])) return t;
      var sign = m[7][0] === '-' ? -1 : 1, hm = m[7].replace(/[^\d]/g, '');
      return t - sign * (parseInt(hm.slice(0, 2), 10) * 60 + parseInt(hm.slice(2), 10)) * 60000;
    }
    return torontoToUtc(+m[1], +m[2], +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
  }
  function firstTime(a, b) { var t = parseTime(a); return t != null && t > 0 ? t : parseTime(b); }
  function countdownParts(endMs, nowMs) {
    var diff = Math.max(0, endMs - nowMs);
    var s = Math.floor(diff / 1000);
    return { done: endMs - nowMs <= 0, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }

  /* ------------------------------------------------------------------ rules */
  // Advanced rules: one per line:  <include|exclude> <what> [equals|contains] [value1, value2]
  // <what> = any URL parameter (utm_campaign, geo, gclid...), or: country, geo, referrer, path, lang, device, page.
  // Use param:<name> to force a URL parameter literally called country/path/... Lines starting with # are comments.
  var SPECIAL = { country: 'country', referrer: 'referrer', referer: 'referrer', ref: 'referrer', path: 'path', url: 'path',
    lang: 'lang', language: 'lang', locale: 'lang', device: 'device', page: 'page', pages: 'page' };
  function makeRule(mode, what, op, values, cat) {
    var subject, param = null, w = lower(what);
    if (w.indexOf('param:') === 0) { subject = 'param'; param = w.slice(6); }
    else if (SPECIAL[w]) subject = SPECIAL[w];
    else { subject = 'param'; param = w; }
    if (!op) op = (subject === 'path' || subject === 'referrer') ? 'contains' : 'equals';
    return { mode: mode, subject: subject, param: param, op: op,
      values: (values || []).map(lower).filter(Boolean), cat: cat || (subject === 'param' ? 'param:' + param : subject) };
  }
  // v1.3.0: the old Targeting fields live here too:  exclude country AU, NZ (detected country) / exclude geo AU (?geo= link
  // tag, kept for the visit) / include page product (page types) / include path contains /collections/halloween (URL parts).
  // 'include page' and 'include path' lines are ONE group (cat 'pages', OR'd, like the old Pages field); no include = all pages.
  // A line that can't be read (bad syntax, a country/geo value that isn't 2 letters) is IGNORED with a console.warn
  // (App.start) and never breaks the pop-up; the other lines still apply.
  var CC_RE = /^[a-z]{2}$/;
  function parseLine(raw, n) { // -> { rule } or { error }
    var line = trim(str(raw).replace(/(^|\s)#.*$/, ''));
    if (!line) return {};
    var m = line.match(/^(include|exclude|only|hide)\s+(\S+)(?:\s+(equals|equal|is|=|contains|has))?(?:\s+(.+))?$/i);
    if (!m) return { error: 'line ' + n + ': ' + trim(raw) };
    var mode = /^(include|only)$/i.test(m[1]) ? 'include' : 'exclude';
    var op = m[3] ? (/^(contains|has)$/i.test(m[3]) ? 'contains' : 'equals') : null;
    var rule = makeRule(mode, m[2], op, splitList(m[4] || '').map(function (v) { return v.replace(/^["']|["']$/g, ''); }));
    if (rule.subject === 'country' || (rule.subject === 'param' && rule.param === 'geo')) {
      var bad = rule.values.filter(function (v) { return !CC_RE.test(v); });
      if (bad.length) return { error: 'line ' + n + ': ' + trim(raw) + ' (not a 2-letter country code: ' + bad.join(', ') + ')' };
      if (rule.subject === 'country' && !rule.values.length) return { error: 'line ' + n + ': ' + trim(raw) + ' (no country code)' };
    }
    if (mode === 'include' && (rule.subject === 'page' || rule.subject === 'path')) rule.cat = 'pages';
    return { rule: rule };
  }
  function parseRules(text) {
    var rules = [], errors = [];
    str(text).split(/\r?\n/).forEach(function (raw, i) {
      var r;
      try { r = parseLine(raw, i + 1); } catch (x) { r = { error: 'line ' + (i + 1) + ': ' + raw }; }
      if (r.error) errors.push(r.error); else if (r.rule) rules.push(r.rule);
    });
    return { rules: rules, errors: errors };
  }
  function pageRules(text) {
    return splitList(text).map(function (item) {
      var k = lower(item);
      if (PAGE_TYPES[k]) return { mode: 'include', subject: 'page', op: 'equals', values: [k], cat: 'pages' };
      return { mode: 'include', subject: 'path', op: 'contains', values: [k], cat: 'pages' };
    });
  }
  function pageKeys(ctx) {
    var t = lower(ctx.template), keys = [t];
    for (var k in PAGE_TYPES) if (PAGE_TYPES[k].indexOf(t) !== -1) keys.push(k);
    return keys;
  }
  function actualValues(rule, ctx) {
    switch (rule.subject) {
      case 'country': return [ctx.country];
      case 'lang': return [ctx.lang, lower(ctx.lang).split('-')[0]];
      case 'device': return [ctx.device];
      case 'referrer': return [ctx.referrer];
      case 'path': return [ctx.path];
      case 'page': return pageKeys(ctx);
      default: return [(ctx.params || {})[rule.param]];
    }
  }
  function matchRule(rule, ctx) {
    var actual = actualValues(rule, ctx).map(lower).filter(Boolean);
    if (!rule.values.length) return actual.length > 0; // "exclude gclid" = parameter present
    return rule.values.some(function (v) {
      return actual.some(function (a) { return rule.op === 'contains' ? a.indexOf(v) !== -1 : a === v; });
    });
  }
  // Any exclude match hides. Includes: grouped by category; every category must match (AND), OR inside a category.
  function evalRules(rules, ctx) {
    var groups = {}, i, r;
    for (i = 0; i < rules.length; i++) {
      r = rules[i];
      if (r.mode === 'exclude') { if (matchRule(r, ctx)) return { ok: false, reason: 'excluded by ' + describe(r) }; }
      else (groups[r.cat] = groups[r.cat] || []).push(r);
    }
    for (var c in groups) {
      if (!groups[c].some(function (x) { return matchRule(x, ctx); })) return { ok: false, reason: 'include not met: ' + c };
    }
    return { ok: true, reason: 'rules ok' };
  }
  function describe(r) { return r.mode + ' ' + (r.subject === 'param' ? r.param : r.subject) + ' ' + r.op + ' ' + r.values.join(','); }

  /* ------------------------------------------------------------------ entry normalisation */
  function pxSize(v, k) { // number_integer px from the style; empty/invalid = default, clamped to the definition's min/max
    var n = Math.round(num(v, NaN)), lim = SIZE_LIMITS[k];
    if (!isFinite(n)) return DEFAULTS[k];
    return Math.min(lim[1], Math.max(lim[0], n));
  }
  function hasOpt(opts, re) { return opts.some(function (o) { return re.test(o); }); }
  function normalize(raw, idx) {
    var e = {}, opts = str(raw.options).split('|').map(lower).filter(Boolean);
    e.index = idx;
    e.name = trim(raw.name) || ('Popup ' + (idx + 1));
    e.code = codeKey(raw.code || raw.handle || e.name);
    // v1.3.0 'Basics: Status' (Off / Test / Live). Set = it decides; empty = the old Active + Test mode fields (migration
    // fallback; the snippet only sends entries that are Live/Test, or empty status + Active ON). Unknown/translated wording = Off.
    var status = lower(raw.status);
    if (status) { e.status = status === 'live' || status === 'test' ? status : 'off'; e.test = status === 'test'; }
    else { e.test = raw.test_mode === true || raw.test_mode === 'true'; e.status = raw.active === false || raw.active === 'false' ? 'off' : (e.test ? 'test' : 'live'); }
    e.priority = Math.round(num(raw.priority, 0));
    e.tags = trim(raw.tags) || ('newsletter, popup-' + e.code.toLowerCase());
    e.headline = trim(raw.headline);
    e.textHtml = trim(raw.text_html);
    // 'Announcement / sales pop-up (no sign-up fields)' (v1.2.0 wording) or 'No email field (announcement)' (old wording): no fields, no POST
    e.announcement = hasOpt(opts, /no email|announcement/);
    // 'Button closes pop-up' (v1.2.0): the announcement's main button only closes (wins over Button link). Sign-up pop-ups ignore it.
    e.buttonCloses = hasOpt(opts, /button closes/);
    e.askFirst = hasOpt(opts, /^ask first name/) || hasOpt(opts, /first name required/);
    e.firstRequired = hasOpt(opts, /first name required/);
    e.askLast = hasOpt(opts, /last name/);
    e.newTab = hasOpt(opts, /new tab/);
    e.hideOnCountdownEnd = hasOpt(opts, /hide (the )?pop-?up when countdown/);
    e.teaserRight = hasOpt(opts, /teaser.*right/);
    e.emailFirst = hasOpt(opts, /email (before|first)/); // 'Ask email before question'. Default: question first, email last
    // v1.4.0 "Don't show again after sign-up or link click": a sign-up or a link click stores a permanent 'used' flag (localStorage, per code)
    e.stopAfterUse = hasOpt(opts, /^don.?t show again/);
    e.buttonLabel = trim(raw.button_label);
    e.buttonLink = trim(raw.button_link);
    e.consent = trim(raw.consent);
    e.countdownEnd = firstTime(raw.countdown_end, raw.countdown_end_iso);
    // Question: first line = question, other lines = answers ("Label" or "Label | tag-slug")
    var qLines = str(raw.question).split(/\r?\n/).map(trim).filter(Boolean);
    e.question = qLines.length > 1 ? qLines[0] : '';
    e.answers = qLines.length > 1 ? qLines.slice(1).map(function (l) {
      var parts = l.split('|'); var label = trim(parts[0]);
      return { label: label, tag: 'q-' + (slugify(parts[1] || '') || slugify(label)) };
    }).filter(function (a) { return a.label && a.tag !== 'q-'; }) : [];
    // v1.3.0 'Steps: Thank-you text' (key success_text): line 1 = headline, next lines = message; empty = default headline.
    // Migration fallback: while the old 'Success headline' field still has a value it is the headline and success_text is the
    // message (old meaning). If success_text already starts with that same headline (half-migrated entry), it isn't shown twice.
    var sLines = trim(raw.success_text).split(/\r?\n/), oldHead = trim(raw.success_headline);
    if (oldHead) {
      if (lower(sLines[0]) === lower(oldHead)) sLines = sLines.slice(1);
      e.successHeadline = oldHead; e.successText = trim(sLines.join('\n'));
    } else {
      e.successHeadline = trim(sLines[0]); e.successText = trim(sLines.slice(1).join('\n'));
    }
    e.discountCode = trim(raw.discount_code);
    e.successButtonLabel = trim(raw.success_button_label);
    var f = lower(raw.font);
    e.font = f.indexOf('theme') !== -1 ? 'theme' : (f.indexOf('system') !== -1 ? 'system' : 'poppins');
    var c = raw.colors || {}; // the snippet already picked campaign field > referenced style > empty for every design key
    e.colors = {
      background: color(c.color_background, DEFAULTS.background), border: isColor(c.color_border) ? trim(c.color_border) : '',
      headline: color(c.color_headline, DEFAULTS.headline), text: color(c.color_text, DEFAULTS.text),
      button: color(c.color_button, DEFAULTS.button), buttonText: color(c.color_button_text, DEFAULTS.buttonText),
      overlay: color(c.color_overlay, DEFAULTS.overlay)
    };
    // v1.2.0 (Pop-up style): consent/small-print color (empty = text color), countdown color (empty = headline color)
    e.colors.consent = isColor(c.color_consent) ? trim(c.color_consent) : '';
    e.colors.countdown = color(c.color_countdown, e.colors.headline);
    e.textSize = pxSize(raw.text_size, 'textSize');
    e.consentSize = pxSize(raw.consent_size, 'consentSize');
    e.imageDesktop = raw.image_desktop && raw.image_desktop.url ? raw.image_desktop : null;
    e.imageMobile = raw.image_mobile && raw.image_mobile.url ? raw.image_mobile : e.imageDesktop;
    // v1.3.0 image: Options 'Image on top' / 'No image' (both = No image). Neither ticked = the old 'Desktop: Image mode' field
    // if it still has a value (migration fallback), else Background (cover).
    var optTop = hasOpt(opts, /^image on top/), optNone = hasOpt(opts, /^no image/), mode = lower(raw.image_mode);
    if (optNone) e.imageMode = 'none';
    else if (optTop) e.imageMode = 'top';
    else e.imageMode = mode.indexOf('top') !== -1 ? 'top' : (mode.indexOf('none') !== -1 ? 'none' : 'background');
    if (!e.imageDesktop && !e.imageMobile) e.imageMode = 'none';
    var sz = str(raw.size).split(/[^\d.]+/).filter(Boolean).map(Number);
    e.size = { width: sz[0] || DEFAULTS.width, minHeight: sz[1] != null ? sz[1] : DEFAULTS.minHeight,
      padding: sz[2] != null ? sz[2] : DEFAULTS.padding, radius: sz[3] != null ? sz[3] : DEFAULTS.radius,
      border: sz[4] != null ? sz[4] : (e.colors.border ? 2 : DEFAULTS.border) };
    // targeting. v1.3.0: everything is in 'Advanced rules'; the old fields Exclude countries / Exclude ?geo= values / Pages /
    // Device are still read while they exist (migration fallback; empty or deleted = nothing added).
    var rules = [], pr = [], parsed = { rules: [], errors: [] };
    try {
      splitList(raw.exclude_countries).length && rules.push(makeRule('exclude', 'country', 'equals', splitList(raw.exclude_countries)));
      splitList(raw.exclude_geo).length && rules.push(makeRule('exclude', 'geo', 'equals', splitList(raw.exclude_geo)));
      pr = pageRules(raw.pages);
      rules = rules.concat(pr);
    } catch (x) { parsed.errors.push('old targeting fields: ' + x); }
    // v1.3.0 device: Options 'Desktop only' / 'Mobile only' (both or neither = all devices). Neither ticked = old Device field.
    var optD = hasOpt(opts, /^desktop only/), optM = hasOpt(opts, /^mobile only/), dev = optD || optM ? '' : lower(raw.device);
    if ((optD && !optM) || (!optD && !optM && dev.indexOf('desktop') !== -1)) rules.push(makeRule('include', 'device', 'equals', ['desktop']));
    else if ((optM && !optD) || (!optD && !optM && dev.indexOf('mobile') !== -1)) rules.push(makeRule('include', 'device', 'equals', ['mobile']));
    var pz = parseRules(raw.rules);
    parsed.rules = pz.rules; parsed.errors = parsed.errors.concat(pz.errors);
    e.ruleErrors = parsed.errors;
    e.rules = rules.concat(parsed.rules);
    e.allowCart = pr.some(function (r) { return r.values[0] === 'cart'; }) ||
      parsed.rules.some(function (r) { return r.mode === 'include' && r.subject === 'page' && r.values.indexOf('cart') !== -1; }); // 'include page cart'
    // schedule
    e.start = firstTime(raw.start, raw.start_iso);
    e.end = firstTime(raw.end, raw.end_iso);
    var trig = { delay: null, scroll: null, exit: false };
    str(raw.open_when).split('|').map(lower).filter(Boolean).forEach(function (o) {
      var m;
      if (/immediate/.test(o)) trig.delay = 0;
      else if ((m = o.match(/scroll\D*(\d+)/))) trig.scroll = trig.scroll == null ? +m[1] : Math.min(trig.scroll, +m[1]);
      else if (/exit/.test(o)) trig.exit = true;
      else if ((m = o.match(/(\d+)/))) trig.delay = trig.delay == null ? +m[1] : Math.min(trig.delay, +m[1]);
    });
    if (trig.delay == null && trig.scroll == null && !trig.exit) trig.delay = DEFAULTS.delay;
    e.triggers = trig;
    var sa = str(raw.show_again).split(/[^\d.]+/).filter(Boolean).map(Number);
    e.closeDays = sa[0] != null ? sa[0] : DEFAULTS.closeDays;
    e.submitDays = sa[1] != null ? sa[1] : DEFAULTS.submitDays;
    e.teaserText = trim(raw.teaser_text);
    return e;
  }

  /* ------------------------------------------------------------------ eligibility & selection */
  var BLOCKED_PATH = /\/(checkout|checkouts|account|challenge|password)(\/|$)/i;
  function testState(ctx) {
    var t = lower(ctx.test || '');
    var st = { show: false, force: false, code: '' };
    if (!t) return st;
    if (t === 'show') st.show = true;
    else if (t === 'force') st.force = true;
    else if (t.indexOf('force:') === 0) { st.force = true; st.code = codeKey(t.slice(6)); }
    else st.code = codeKey(t);
    return st;
  }
  // v1.4.0 frequency rules, in this order (the same for live visitors and, after the first forced opening, for test links):
  //  used (option "Don't show again after sign-up or link click") > signed up (2nd 'Show again' number, default 365 days)
  //  > closed this visit (sessionStorage, any page, whatever the days say) > closed less than N days ago (1st number, default 5).
  function submittedRecently(e, state, now) {
    return !!(state && state.submitted && (e.submitDays <= 0 || now - state.submitted < e.submitDays * DAY));
  }
  function frequencyBlocked(e, state, ctx) {
    if (!state) state = {};
    if (e.stopAfterUse && state.used) return 'used';
    if (submittedRecently(e, state, ctx.now)) return 'submitted';
    if ((ctx.sessionClosed || {})[e.code]) return 'closed this visit';
    if (e.closeDays > 0 && state.closed && ctx.now - state.closed < e.closeDays * DAY) return 'closed';
    return '';
  }
  // opts.ignoreFrequency: the teaser check (same rules, the pop-up itself was closed).
  // v1.4.0: a test link (?hi_popup=show|force|CODE, kept for the visit) skips the frequency rules only for the FIRST opening of
  // each code in this visit (SS_FORCED is written when it opens). After that the frequency rules apply as for live visitors.
  // The theme editor (request.design_mode) always shows it.
  function evaluate(e, ctx, state, opts) {
    var t = testState(ctx), why;
    if (t.code && t.code !== e.code) return { ok: false, reason: 'test link targets another code' };
    var testing = t.show || t.force || !!t.code || ctx.designMode;
    if (e.test && !testing) return { ok: false, reason: 'test mode (needs ?hi_popup=show|' + e.code + ')' };
    var firstForced = ctx.designMode || ((t.show || t.force || !!t.code) && !(ctx.forced || {})[e.code]);
    var checkFreq = !firstForced && !(opts && opts.ignoreFrequency);
    if (t.force) {
      if (checkFreq && (why = frequencyBlocked(e, state, ctx))) return { ok: false, reason: 'suppressed: ' + why + ' (force: only the first opening this visit is forced)', suppressed: why };
      return { ok: true, reason: firstForced ? 'forced (first opening this visit)' : 'forced' };
    }
    if (ctx.acceptsMarketing) return { ok: false, reason: 'logged-in customer already subscribed' };
    var tpl = lower(ctx.template);
    if (lower(ctx.templateDir) === 'customers' || tpl === 'password' || tpl === 'gift_card' || BLOCKED_PATH.test(ctx.path || ''))
      return { ok: false, reason: 'never on account/checkout/challenge pages' };
    if ((tpl === 'cart' || /\/cart\/?$/i.test(ctx.path || '')) && !e.allowCart) return { ok: false, reason: 'cart page (add "include page cart" to Advanced rules to allow)' };
    if (e.start && ctx.now < e.start) return { ok: false, reason: 'before start date' };
    if (e.end && ctx.now >= e.end) return { ok: false, reason: 'after end date' };
    if (e.hideOnCountdownEnd && e.countdownEnd && ctx.now >= e.countdownEnd) return { ok: false, reason: 'countdown ended' };
    if (checkFreq && (why = frequencyBlocked(e, state, ctx))) return { ok: false, reason: 'suppressed: ' + why, suppressed: why };
    var res = evalRules(e.rules, ctx);
    if (res.ok && firstForced && !ctx.designMode) res.reason = 'ok (test link: first opening this visit, frequency skipped)';
    return res;
  }
  function selectEntry(entries, ctx, getState) {
    var best = null, results = [];
    entries.forEach(function (e) {
      var r = evaluate(e, ctx, getState(e.code));
      results.push({ code: e.code, priority: e.priority, ok: r.ok, reason: r.reason, suppressed: r.suppressed });
      if (r.ok && (!best || e.priority > best.priority)) best = e; // ties: first entry wins
    });
    return { entry: best, results: results };
  }

  /* ------------------------------------------------------------------ context */
  function collectParams(search, ss) {
    var saved = sGet(ss, SS_PARAMS) || {};
    try {
      new URLSearchParams(search || '').forEach(function (v, k) {
        k = lower(k);
        if (!k || k === 'hi_popup' || k === 'customer_posted' || k === 'form_key' || k === 'form_type') return;
        saved[k] = str(v).slice(0, 200);
      });
    } catch (e) {}
    sSet(ss, SS_PARAMS, saved);
    return saved;
  }
  function landingReferrer(ss, doc, host) {
    var saved = sGet(ss, SS_REF);
    if (saved !== null) return saved;
    var r = str(doc.referrer), ext = '';
    try { if (r && new URL(r).hostname !== host) ext = r; } catch (e) {}
    sSet(ss, SS_REF, ext);
    return ext;
  }

  /* ------------------------------------------------------------------ CSS (injected once) */
  // v1.2.0 spacing = the Klaviyo 'Halloween Sale' form (VyrSS9): every block has 10 px padding top/bottom inside a 20 px pop-up padding,
  // so block -> block = 20 px and pop-up edge -> first/last block = 20 + 10 = 30 px. Here: ONE gap (--hip-gap, flex column gap on the
  // step and inside the form, no margins on the blocks) and edge = Size padding + gap/2, top and bottom alike.
  var GAP = 20;
  // v1.4.0 item 1: the countdown -> main button gap scales with the pop-up width like the Klaviyo reference
  // (refs/klaviyo_spacing_ref_2026-10-24.png, tools/measure_ref_v14.py: gap = 7.34% of the pop-up width on desktop AND mobile).
  // 600 px wide = 44.0 px, 343 px (375 viewport) = 25.2 px, 288 px (320 viewport) = 21.1 px; never less than the 20 px gap.
  // Only this one gap: a visible countdown directly followed by the main button. Every other gap stays 20 px, edges 30 px.
  var CD_GAP_RATIO = 0.0734;
  // 'Small print: Color / Size (px)' targets this ONE selector. Repoint it here to style another block.
  var SMALL_PRINT_SEL = '.hip__consent';
  var CSS = [
    // z-index 2147483600: above the theme, cookie banner and apps, but below hCaptcha's challenge (body-level, 2147483647)
    '.hip{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;font-family:var(--hip-font-body);-webkit-font-smoothing:antialiased}',
    '.hip[hidden],.hip-teaser[hidden],.hip [hidden]{display:none!important}',
    '.hip *,.hip *::before,.hip *::after{box-sizing:border-box}',
    '.hip__overlay{position:absolute;inset:0;background:var(--hip-overlay);touch-action:none;overscroll-behavior:contain}',
    '.hip>.hip__overlay,.hip .hip__sr{display:block}', // Dawn's base.css has div:empty/span:empty{display:none}, which hid the dimmed overlay
    '.hip__dialog{position:relative;width:100%;max-width:var(--hip-w);min-height:min(var(--hip-h),calc(100vh - 32px));max-height:calc(100vh - 32px);overflow:auto;overscroll-behavior:contain;display:flex;flex-direction:column;background-color:var(--hip-bg);background-image:var(--hip-img-d);background-size:cover;background-position:center;background-repeat:no-repeat;border:var(--hip-bw) solid var(--hip-bc);border-radius:var(--hip-r);color:var(--hip-text);text-align:center;box-shadow:0 10px 40px rgba(0,0,0,.25)}',
    '@supports (height:100dvh){.hip__dialog{min-height:min(var(--hip-h),calc(100dvh - 32px));max-height:calc(100dvh - 32px)}}',
    '.hip__dialog:focus,.hip [tabindex="-1"]:focus{outline:none}',
    '.hip__media{margin:0;line-height:0}.hip__media img{display:block;width:100%;height:auto;border-radius:calc(var(--hip-r) - var(--hip-bw)) calc(var(--hip-r) - var(--hip-bw)) 0 0}',
    '.hip__body{flex:1;display:flex;flex-direction:column;justify-content:center;padding:var(--hip-edge)}',
    '.hip__step{--hip-gap:' + GAP + 'px;display:flex;flex-direction:column;gap:var(--hip-gap);width:100%;max-width:520px;margin:0 auto}',
    '.hip__step>*{margin:0!important}', // one spacing system: only the flex gap, never stacked/collapsed margins
    // v1.4.0 item 1 (see CD_GAP_RATIO): 100cqw = the dialog's inner width (container below), + its 2 borders = the pop-up width.
    // Browsers without container units drop this declaration and keep the 20 px gap.
    '.hip__dialog{container-type:inline-size}',
    '.hip__step>.hip__timer:not([hidden])+[data-hip-cta]{margin-top:calc(max(var(--hip-gap),(100cqw + 2 * var(--hip-bw)) * ' + CD_GAP_RATIO + ') - var(--hip-gap))!important}',
    '.hip__close{position:absolute;top:6px;right:6px;z-index:2;width:35px;height:35px;padding:0;margin:0;border:0;background:transparent;color:var(--hip-close);cursor:pointer;display:flex;align-items:center;justify-content:center;border-radius:50%}',
    '.hip__close svg{width:18px;height:18px}.hip__close:focus-visible,.hip button:focus-visible,.hip a:focus-visible,.hip input:focus-visible{outline:2px solid var(--hip-focus);outline-offset:2px}',
    '.hip__headline{margin:0;font-family:var(--hip-font-head);font-weight:var(--hip-font-weight);font-size:clamp(26px,7vw,38px);line-height:1.15;color:var(--hip-headline);letter-spacing:0;overflow-wrap:anywhere}',
    '.hip__text{font-size:var(--hip-text-size,16px);line-height:1.5;color:var(--hip-text)}.hip__text>*{margin:0 0 .5em}.hip__text>*:last-child{margin-bottom:0}.hip__text a{color:inherit}',
    // Countdown (v1.2.0): every box has a FIXED width and height (em of --hip-cd-fs), so it never resizes when the digits change.
    // Sized to fit 4 boxes in one row at 320 px viewport width (Size padding up to 28 px; labels up to 'Segundos' at 9 px). 3+ digit days shrink the digits, not the box.
    '.hip__timer{--hip-cd-fs:clamp(24px,7.5vw,50px);display:flex;flex-wrap:nowrap;justify-content:center;gap:clamp(4px,1.5vw,10px)}',
    '.hip__unit{flex:0 0 auto;width:calc(var(--hip-cd-fs) * 2);height:calc(var(--hip-cd-fs) * 1.05 + 30px);min-width:0;padding:6px 1px;border-radius:10px;background:var(--hip-card);display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden}',
    '.hip__num{display:block;width:100%;height:calc(var(--hip-cd-fs) * 1.05);font-family:var(--hip-font-head);font-weight:700;font-size:var(--hip-cd-fs);line-height:1.05;text-align:center;white-space:nowrap;color:var(--hip-countdown);font-variant-numeric:tabular-nums;font-feature-settings:"tnum" 1}',
    '.hip__num--3{font-size:calc(var(--hip-cd-fs) * .7)}.hip__num--4{font-size:calc(var(--hip-cd-fs) * .52)}',
    '.hip__num--3,.hip__num--4{line-height:calc(var(--hip-cd-fs) * 1.05)}',
    '.hip__lbl{display:block;max-width:100%;font-size:clamp(9px,2.8vw,12px);line-height:1.2;height:1.2em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--hip-countdown);opacity:.9;margin-top:2px}',
    '.hip__form{display:flex;flex-direction:column;gap:var(--hip-gap,' + GAP + 'px);margin:0}', // field -> field -> button = the same gap
    '.hip__field{display:block;text-align:left}',
    '.hip__form>div:not(.hip__field){position:absolute!important}', // Shopify's invisible hCaptcha widget div: out of the flow, so it adds no extra gap
    '.hip__input{display:block;width:100%;height:50px;padding:0 20px;border:1px solid var(--hip-input-border);border-radius:60px;background:#fff;color:#121212;font:inherit;font-size:16px;-webkit-appearance:none;appearance:none}',
    '.hip__input[aria-invalid=true]{border-color:#c4001a;box-shadow:0 0 0 1px #c4001a}',
    '.hip__btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:54px;padding:8px 24px;border:0;border-radius:60px;background:var(--hip-btn);color:var(--hip-btn-text);font-family:var(--hip-font-head);font-weight:700;font-size:18px;line-height:1.2;text-decoration:none;cursor:pointer}',
    '.hip__btn:hover{opacity:.9}.hip__btn[disabled]{opacity:.6;cursor:progress}',
    '.hip__answers{display:flex;flex-direction:column;gap:10px}',
    '.hip__answer{min-height:48px;padding:8px 20px;border:1px solid var(--hip-input-border);border-radius:60px;background:transparent;color:var(--hip-text);font:inherit;font-size:16px;cursor:pointer}',
    '.hip__answer:hover{background:rgba(127,127,127,.12)}',
    '.hip__link{align-self:center;background:none;border:0;padding:4px;color:var(--hip-text);font:inherit;font-size:14px;text-decoration:underline;cursor:pointer}',
    SMALL_PRINT_SEL + '{margin:0;font-size:var(--hip-consent-size,12px);line-height:1.4;color:var(--hip-consent);opacity:var(--hip-consent-o,.85)}',
    '.hip__error{margin:0;padding:8px 12px;border-radius:8px;background:#fff;color:#a30015;font-size:14px;text-align:left}',
    '.hip__code{display:flex;align-items:stretch;justify-content:center;border:2px dashed var(--hip-headline);border-radius:12px;overflow:hidden}',
    '.hip__code-value{flex:1;display:flex;align-items:center;justify-content:center;padding:10px 14px;font-family:var(--hip-font-head);font-weight:700;font-size:24px;letter-spacing:2px;color:var(--hip-headline);user-select:all}',
    '.hip__copy{border:0;padding:0 18px;background:var(--hip-btn);color:var(--hip-btn-text);font:inherit;font-weight:700;font-size:14px;cursor:pointer}',
    '.hip__sr{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}',
    '.hip-teaser{position:fixed;bottom:16px;z-index:2147483500;display:flex;align-items:center;gap:4px;padding:0;border-radius:10px;background:var(--hip-btn);color:var(--hip-btn-text);box-shadow:0 4px 30px rgba(0,0,0,.15);font-family:var(--hip-font-body)}',
    '.hip-teaser--left{left:16px}.hip-teaser--right{right:16px}',
    '.hip-teaser__open{border:0;background:transparent;color:inherit;font:inherit;font-weight:600;font-size:14px;padding:12px 4px 12px 16px;cursor:pointer}',
    '.hip-teaser__x{border:0;background:transparent;color:inherit;width:32px;height:40px;cursor:pointer;font-size:18px;line-height:1;opacity:.8}',
    // no entrance animation and no transitions: the dialog and every step are fully visible on the first frame
    '@media (max-width:749px){.hip__dialog{max-width:none;background-image:var(--hip-img-m)}}'
  ].join('\n');

  function injectCss(cfg, entry) {
    if (document.getElementById('hi-popup-css')) return;
    var css = CSS, f = cfg.fonts || {};
    if (entry.font === 'poppins' && (f.poppins700 || f.poppins400)) {
      css = (f.poppins400 ? '@font-face{font-family:"HI Poppins";src:url("' + f.poppins400 + '") format("woff2");font-weight:400;font-style:normal;font-display:swap}\n' : '') +
        (f.poppins700 ? '@font-face{font-family:"HI Poppins";src:url("' + f.poppins700 + '") format("woff2");font-weight:700;font-style:normal;font-display:swap}\n' : '') + css;
    }
    var st = document.createElement('style');
    st.id = 'hi-popup-css';
    st.textContent = css;
    document.head.appendChild(st);
  }
  var SYSTEM_STACK = 'system-ui,-apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif';
  function styleVars(e) {
    var c = e.colors, font = { poppins: '"HI Poppins",Poppins,' + SYSTEM_STACK, theme: 'var(--font-heading-family,' + SYSTEM_STACK + ')', system: SYSTEM_STACK }[e.font];
    var body = e.font === 'theme' ? 'var(--font-body-family,' + SYSTEM_STACK + ')' : font;
    var v = {
      '--hip-w': e.size.width + 'px', '--hip-h': e.size.minHeight + 'px', '--hip-p': e.size.padding + 'px', '--hip-edge': (e.size.padding + GAP / 2) + 'px', '--hip-r': e.size.radius + 'px',
      '--hip-bw': (c.border ? e.size.border : 0) + 'px', '--hip-bc': c.border || 'transparent', '--hip-bg': c.background,
      '--hip-headline': c.headline, '--hip-text': c.text, '--hip-btn': c.button, '--hip-btn-text': c.buttonText,
      '--hip-text-size': e.textSize + 'px', '--hip-consent': c.consent || c.text, '--hip-consent-size': e.consentSize + 'px',
      '--hip-consent-o': c.consent ? '1' : '.85', '--hip-countdown': c.countdown || c.headline,
      '--hip-overlay': hexA(c.overlay, 0.6), '--hip-close': c.headline, '--hip-focus': c.headline,
      '--hip-input-border': c.border || hexA(c.text, 0.4), '--hip-card': 'rgba(0,0,0,.28)',
      '--hip-font-head': font, '--hip-font-body': body, '--hip-font-weight': e.font === 'theme' ? 'var(--font-heading-weight,700)' : '700',
      '--hip-img-d': e.imageMode === 'background' && e.imageDesktop ? cssUrl(e.imageDesktop.url) : 'none',
      '--hip-img-m': e.imageMode === 'background' && e.imageMobile ? cssUrl(e.imageMobile.url) : 'none'
    };
    return Object.keys(v).map(function (k) { return k + ':' + v[k]; }).join(';');
  }

  /* ------------------------------------------------------------------ submit (Shopify native customer form) */
  // The store has Shopify's storefront-forms hCaptcha on customer forms (inline <script id="captcha-bootstrap"> + cdn.shopify.com
  // ce_storefront_forms_captcha_hcaptcha.v1.5.3). It binds a form on focusin/change, then on the form's submit event it runs
  // invisible hCaptcha, adds h-captcha-response and does the real POST itself. A POST without that token gets 400, so we never
  // fetch(): we validate, save a pending marker, then form.requestSubmit() and let Shopify's script finish (full page load).
  // requestSubmit() is always called from a fresh task (never inside the visitor's own submit event): the browser silently
  // ignores a requestSubmit() made while that form's submit event is still being dispatched (HTML "firing submission events").
  // Shopify's script swallows hCaptcha errors (console.error only, execute() has no close/error callback), so we watch it:
  // the execute() promise (tapped), the challenge iframe and page unload. Every failure ends with a visible message.
  // No page reload (2026-10-22): Shopify's iife (v1.5.3) remembers `typeof form.submit === 'function' ? form.submit :
  // HTMLFormElement.prototype.submit` when it binds, and calls it after it has put the token in the form. We give the form
  // its own submit() BEFORE it is bound, so that call reaches us: with a token we POST the same fields with fetch() and
  // read the answer (thank-you / form error / /challenge). Anything unexpected -> the normal native POST (page reload).
  // We never call hCaptcha ourselves and never send without Shopify's token.
  // ONE POST per visitor (2026-10-22, v1.1.0): with a question, the question comes first and the email last (or, with the
  // Options choice 'Ask email before question', email first and the POST after the answer / Skip). The answer is held in
  // memory and goes out as tag q-<answer> in that single POST (fetch, or the reload fallback). Guards: busy button, a
  // per-visit list of emails already signed up per code (sessionStorage), and no POST at all after success.
  var TAKEN_RE = /taken|already|exist|déjà|bereits|già|ya (está|existe)|registrad/i;
  var CAPTCHA_WAIT = 15000;  // max wait for Shopify's script to bind hCaptcha to the form
  var START_WAIT = 5000;     // after the hand-off: hCaptcha must start (or the page must start loading)
  var CHECK_WAIT = 45000;    // hCaptcha started but no answer and no visible challenge (hung / blocked)
  var LEAVE_WAIT = 15000;    // token added (or no captcha): the POST must make the page leave
  var POLL = 250;
  var FETCH_WAIT = 20000;    // fetch() sign-up: max wait for Shopify's answer
  var captchaTap = null;     // receives every hcaptcha.execute() promise while a hand-off is running
  function tapHcaptcha(win) { // wrap hcaptcha.execute once so we see the promise Shopify's script gets
    var hc = win.hcaptcha;
    if (!hc || typeof hc.execute !== 'function') return false;
    if (hc.execute.__hip) return true;
    var orig = hc.execute;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { if (captchaTap) captchaTap(r); } catch (x) {}
      return r;
    };
    wrapped.__hip = true;
    try { hc.execute = wrapped; } catch (x) { return false; }
    return hc.execute === wrapped;
  }
  // hCaptcha's challenge is an iframe in a container appended to <body> (outside the pop-up): visible = puzzle on screen
  function challengeVisible(doc, form) {
    var fr = doc.querySelectorAll('iframe[src*="hcaptcha"]');
    for (var i = 0; i < fr.length; i++) {
      if (form && form.contains(fr[i])) continue; // the invisible widget itself
      try {
        var r = fr[i].getBoundingClientRect(), cs = (doc.defaultView || window).getComputedStyle(fr[i]);
        if (cs.visibility !== 'hidden' && cs.display !== 'none' && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < 5000) return true;
      } catch (x) {}
    }
    return false;
  }
  function requestSubmit(form) {
    if (typeof form.requestSubmit === 'function') return form.requestSubmit();
    var ev; try { ev = new Event('submit', { bubbles: true, cancelable: true }); } catch (x) { ev = document.createEvent('Event'); ev.initEvent('submit', true, true); }
    if (form.dispatchEvent(ev)) HTMLFormElement.prototype.submit.call(form); // old Safari: same events, then the native POST
  }
  function returnPath(loc) {
    var q = '';
    try {
      var sp = new URLSearchParams(loc.search || '');
      ['customer_posted', 'form_key', 'form_type'].forEach(function (k) { sp.delete(k); });
      q = sp.toString();
    } catch (e) {}
    var p = str(loc.pathname || '/'); if (p.charAt(0) !== '/' || p.charAt(1) === '/') p = '/';
    return p + (q ? '?' + q : '');
  }

  /* ------------------------------------------------------------------ the app */
  function App(cfg, opts) {
    opts = opts || {};
    this.cfg = cfg;
    this.ctxBase = cfg.ctx || {};
    this.win = opts.window || window;
    this.ls = store('localStorage');
    this.ss = store('sessionStorage');
    this.now = opts.now || function () { return Date.now(); };
    this.requestSubmit = opts.requestSubmit || requestSubmit;
    this.later = opts.setTimeout || function (fn, ms) { return setTimeout(fn, ms); };
    this.captchaWait = opts.captchaWait || CAPTCHA_WAIT;
    this.startWait = opts.startWait || START_WAIT;
    this.checkWait = opts.checkWait || CHECK_WAIT;
    this.leaveWait = opts.leaveWait || LEAVE_WAIT;
    this.fetchWait = opts.fetchWait || FETCH_WAIT;
    this.fetch = opts.fetch || (typeof this.win.fetch === 'function' ? this.win.fetch.bind(this.win) : null);
    this.ajax = opts.ajax !== false;
    this.navigate = opts.navigate || function (u) { window.location.assign(u); };
    this.t = strings(this.ctxBase.locale);
    this.entries = (cfg.entries || []).map(normalize).filter(function (e) { return e.status !== 'off'; }); // Status Off = off everywhere
    this.form = document.getElementById('HiPopupForm');
    this.timers = [];
  }
  App.prototype.state = function (code) { return sGet(this.ls, LS_PREFIX + code) || {}; };
  App.prototype.saveState = function (code, patch) {
    var s = this.state(code); for (var k in patch) s[k] = patch[k]; sSet(this.ls, LS_PREFIX + code, s); return s;
  };
  App.prototype.context = function () {
    var loc = this.win.location, b = this.ctxBase, params, test;
    var q = null;
    try { q = new URLSearchParams(loc.search).get('hi_popup'); } catch (e) {}
    if (q != null) {
      q = lower(q);
      if (q === 'reset') { clearAll(this.ls, this.ss); q = ''; } // every hi_popup* key in localStorage + sessionStorage, all codes
      if (q === 'off' || q === '') sDel(this.ss, SS_TEST); else sSet(this.ss, SS_TEST, q);
    }
    test = sGet(this.ss, SS_TEST) || '';
    params = collectParams(loc.search, this.ss);
    var mobile = false;
    try { mobile = this.win.matchMedia(MOBILE_MQ).matches; } catch (e) {}
    return {
      now: this.now(), params: params, referrer: landingReferrer(this.ss, document, loc.hostname),
      country: str(b.country).toUpperCase(), lang: str(b.locale || 'en'), template: str(b.template),
      templateDir: str(b.templateDir), path: str(loc.pathname || b.path), device: mobile ? 'mobile' : 'desktop',
      designMode: b.designMode === true, acceptsMarketing: b.acceptsMarketing === true, test: test,
      sessionClosed: sGet(this.ss, SS_CLOSED) || {}, forced: sGet(this.ss, SS_FORCED) || {}, teaser: sGet(this.ss, SS_TEASER) || {}
    };
  };
  App.prototype.start = function () {
    var self = this;
    var ctx = this.ctx = this.context();
    if (!this.form) return;
    this.form.removeAttribute('data-nocaptcha'); // must stay protected: Shopify adds the hCaptcha token on submit
    if (/(^|[?&])hi_popup_ajax=0(&|$)/.test(str(this.win.location.search))) sSet(this.ss, SS_NOAJAX, { t: ctx.now, why: 'url' });
    this.installHook(this.form);
    this.warnRules();
    if (this.resumePending(ctx)) return;
    var sel = selectEntry(this.entries, ctx, function (c) { return self.state(c); });
    this.results = sel.results;
    if (ctx.test || ctx.designMode) this.debug(sel);
    if (sel.entry) { this.armTriggers(sel.entry, !!(ctx.test || ctx.designMode)); return; }
    // v1.4.0: nothing to open -> the teaser tab, only if it is 'on' for this visit (set by a close on an earlier page of this
    // visit, until the visitor closes the tab). A later visit within the N days shows nothing. Never after sign-up or 'used'.
    var best = this.teaserCandidate(ctx);
    if (best) this.showTeaser(best);
  };
  App.prototype.teaserCandidate = function (ctx) {
    var self = this, best = null;
    this.entries.forEach(function (e) {
      if (!e.teaserText || (ctx.teaser || {})[e.code] !== 'on') return;
      var st = self.state(e.code);
      if ((e.stopAfterUse && st.used) || submittedRecently(e, st, ctx.now)) return;
      if (evaluate(e, ctx, st, { ignoreFrequency: true }).ok && (!best || e.priority > best.priority)) best = e; // same rules (pages, dates, test link)
    });
    return best;
  };
  App.prototype.sessionMap = function (key, code, val) { var m = sGet(this.ss, key) || {}; m[code] = val; sSet(this.ss, key, m); if (this.ctx) this.ctx[{ hi_popup_closed_session: 'sessionClosed', hi_popup_forced: 'forced', hi_popup_teaser: 'teaser' }[key]] = m; };
  App.prototype.debug = function (sel) {
    try {
      var c = this.win.console;
      c.info('[hi-popup ' + VERSION + '] chosen:', sel.entry ? sel.entry.code : 'none', '| test:', this.ctx.test || '-', '| country:', this.ctx.country, '| params:', this.ctx.params);
      if (c.table) c.table(sel.results);
    } catch (e) {}
  };
  // v1.3.0: every visitor's console (not only test links) names the Advanced-rules lines that were ignored.
  App.prototype.warnRules = function () {
    try {
      var c = this.win.console;
      this.entries.forEach(function (e) { if (e.ruleErrors.length) c.warn('[hi-popup] ' + e.code + ' rules not understood (line ignored):', e.ruleErrors); });
    } catch (e) {}
  };
  App.prototype.armTriggers = function (e, testing) {
    var self = this, fired = false, t = e.triggers, mobile = this.ctx.device === 'mobile';
    function fire() { if (fired) return; fired = true; cleanup(); self.open(e, 'offer'); }
    var listeners = [];
    function on(target, type, fn, o) { target.addEventListener(type, fn, o); listeners.push([target, type, fn, o]); }
    function cleanup() { listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); }); self.timers.forEach(clearTimeout); }
    var delay = t.delay;
    if (t.exit && mobile && delay == null) delay = DEFAULTS.delay; // phones have no exit intent: open like an empty 'Open when'
    this.fire = fire;
    if (delay != null && delay <= 0) { fire(); return; } // immediate: no timer, no extra task
    if (delay != null) this.timers.push(setTimeout(fire, delay * 1000));
    warmImage(e, mobile); // deliberate trigger: fetch + decode the image now so it is ready when the pop-up opens
    if (t.scroll != null) {
      on(this.win, 'scroll', function () {
        var d = document.documentElement, max = (d.scrollHeight - this.innerHeight) || 1;
        if (((this.pageYOffset || d.scrollTop) / max) * 100 >= t.scroll) fire();
      }, { passive: true });
    }
    if (t.exit && !mobile) on(document, 'mouseout', function (ev) { if (!ev.relatedTarget && ev.clientY <= 0) fire(); });
  };
  // Never waited on: the dialog shows at once and the image paints when it arrives. This only starts the download/decode early.
  function warmImage(e, mobile) {
    try {
      var im = e.imageMode !== 'none' && (mobile ? e.imageMobile : e.imageDesktop);
      if (!im || !im.url || typeof Image !== 'function') return;
      var i = new Image(); i.decoding = 'async'; i.src = im.url;
      if (i.decode) i.decode().then(null, function () {});
    } catch (x) {}
  }

  /* ---------- after the page reload: reopen on the next step */
  App.prototype.resumePending = function (ctx) {
    var p = sGet(this.ss, SS_PENDING), loc = this.win.location;
    if (!p) return false;
    if (BLOCKED_PATH.test(ctx.path)) return false; // on /challenge: keep the marker for the page after it
    sDel(this.ss, SS_PENDING);
    if (ctx.now - (p.t || 0) > 30 * 60000) return false;
    var e = this.entries.filter(function (x) { return x.code === p.code; })[0];
    if (!e) return false;
    var ref = '', nav = '';
    try { ref = new URL(document.referrer).pathname; } catch (x) {}
    try { nav = this.win.performance.getEntriesByType('navigation')[0].type; } catch (x) {}
    var errEl = document.querySelector('[data-hi-form-errors]');
    var errMsg = errEl ? errEl.getAttribute('data-hi-form-errors') : '';
    var bad = errEl && !TAKEN_RE.test(errMsg);
    var posted = !bad && (/(^|[?&])customer_posted=true/.test(str(loc.search)) || !!document.querySelector('[data-hi-form-ok]') || !!errEl ||
      /\/challenge/.test(ref) || (p.sent && p.ret === returnPath(loc) && nav !== 'reload' && nav !== 'back_forward'));
    if (p.stage === 'answer') { if (posted || bad) { this.completed = true; this.open(e, 'success'); return true; } return false; } // v1.0.0 step-2 marker
    if (posted) { // the one POST went through: just the thank-you screen, never a second POST
      this.complete(e, p.email);
      this.open(e, 'success');
      return true;
    }
    if (bad) { // same email, names and answer: a retry is again exactly one POST
      if (p.answered) { this.answered = true; this.answerSel = p.tag ? { tag: p.tag } : null; this.emailReady = true; }
      this.open(e, 'offer'); this.refill(p); this.showError(errMsg || this.t.errGeneric); return true;
    }
    return false;
  };
  App.prototype.refill = function (p) { // same email (+ names) to fix an error
    var f = this.form;
    ['email', 'first_name', 'last_name'].forEach(function (k) {
      var i = f.querySelector('[name="contact[' + k + ']"]'); if (i && p[k]) i.value = p[k];
    });
  };

  /* ---------- rendering */
  App.prototype.build = function (e) {
    var t = this.t, self = this, root = document.createElement('div');
    var titleId = 'hip-title-' + e.code.replace(/[^A-Z0-9_-]/gi, '');
    var link = localizeLink(e.buttonLink, this.ctxBase.root, this.win.location.origin);
    root.className = 'hip' + (e.imageMode === 'top' ? ' hip--top' : '');
    root.setAttribute('data-hip', e.code);
    root.setAttribute('style', styleVars(e));
    var media = '';
    if (e.imageMode === 'top' && e.imageDesktop) {
      media = '<picture class="hip__media">' + (e.imageMobile ? '<source media="' + MOBILE_MQ + '" srcset="' + esc(e.imageMobile.url) + '">' : '') +
        '<img src="' + esc(e.imageDesktop.url) + '" alt="" decoding="async" fetchpriority="high" ' + (e.imageDesktop.w ? 'width="' + e.imageDesktop.w + '" height="' + e.imageDesktop.h + '"' : '') + '></picture>';
    }
    var headline = e.headline ? '<h2 class="hip__headline" id="' + titleId + '">' + esc(e.headline) + '</h2>' : '';
    var timer = e.countdownEnd ? '<div class="hip__timer" data-hip-timer role="timer" aria-live="off">' +
      ['d', 'h', 'm', 's'].map(function (u) {
        var lbl = { d: t.days, h: t.hours, m: t.minutes, s: t.seconds }[u];
        return '<div class="hip__unit"><span class="hip__num" data-hip-' + u + '>00</span><span class="hip__lbl">' + esc(lbl) + '</span></div>';
      }).join('') + '</div>' : '';
    var offer;
    if (e.announcement) {
      var lab = esc(e.buttonLabel || t.shop), ctaLink = e.buttonCloses ? '' : link; // 'Button closes pop-up' wins over Button link
      offer = ctaLink ? '<a class="hip__btn" data-hip-cta href="' + esc(ctaLink) + '"' + (e.newTab ? ' target="_blank" rel="noopener"' : '') + '>' + lab + '</a>'
        : '<button type="button" class="hip__btn" data-hip-cta>' + lab + '</button>';
    } else {
      offer = '<div class="hip__form" data-hip-formslot></div>';
    }
    var step1 = '<div class="hip__step" data-hip-step="offer">' + headline +
      (e.textHtml ? '<div class="hip__text">' + e.textHtml + '</div>' : '') + timer + offer +
      '<p class="hip__error" data-hip-error role="alert" hidden></p>' +
      (!e.announcement ? '<p class="hip__consent">' + esc(e.consent || t.consent) + '</p>' : '') + '</div>';
    var step2 = e.answers.length ? '<div class="hip__step" data-hip-step="question" hidden><h2 class="hip__headline" data-hip-qtitle tabindex="-1">' + esc(e.question) + '</h2>' +
      '<div class="hip__answers">' + e.answers.map(function (a, i) { return '<button type="button" class="hip__answer" data-hip-answer="' + i + '">' + esc(a.label) + '</button>'; }).join('') +
      '</div><button type="button" class="hip__link" data-hip-skip>' + esc(t.skipQ) + '</button></div>' : '';
    var succBtn = '';
    if (e.successButtonLabel) {
      var slink = !e.announcement ? link : '';
      succBtn = slink ? '<a class="hip__btn" data-hip-sbtn href="' + esc(slink) + '"' + (e.newTab ? ' target="_blank" rel="noopener"' : '') + '>' + esc(e.successButtonLabel) + '</a>'
        : '<button type="button" class="hip__btn" data-hip-sbtn>' + esc(e.successButtonLabel) + '</button>';
    }
    var step3 = '<div class="hip__step" data-hip-step="success" hidden><h2 class="hip__headline" data-hip-stitle tabindex="-1">' + esc(e.successHeadline || t.successHeadline) + '</h2>' +
      (e.successText ? '<div class="hip__text">' + esc(e.successText).replace(/\r?\n/g, '<br>') + '</div>' : '') +
      (e.discountCode ? '<div class="hip__code"><span class="hip__code-value" data-hip-codeval aria-label="' + esc(t.code) + '">' + esc(e.discountCode) + '</span>' +
        '<button type="button" class="hip__copy" data-hip-copy>' + esc(t.copy) + '</button></div><span class="hip__sr" data-hip-live aria-live="polite"></span>' : '') +
      succBtn + '</div>';
    root.innerHTML = '<div class="hip__overlay" data-hip-close></div>' +
      '<div class="hip__dialog" role="dialog" aria-modal="true" tabindex="-1" ' + (e.headline ? 'aria-labelledby="' + titleId + '"' : 'aria-label="' + esc(t.dialog) + '"') + '>' +
      '<button type="button" class="hip__close" data-hip-close aria-label="' + esc(t.close) + '"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" fill="none"/></svg></button>' +
      media + '<div class="hip__body">' + step1 + step2 + step3 + '</div></div>';
    if (!e.announcement) this.mountForm(e, root.querySelector('[data-hip-formslot]'));
    return root;
  };
  App.prototype.mountForm = function (e, slot) {
    var t = this.t, f = this.form, uid = 'hip-' + e.code.toLowerCase().replace(/[^a-z0-9]/g, '');
    // keep Shopify's hidden inputs (form_type, utf8, any token); drop previously generated fields
    Array.prototype.slice.call(f.querySelectorAll('[data-hip-gen]')).forEach(function (n) { n.parentNode.removeChild(n); });
    f.className = 'hip__form';
    f.setAttribute('novalidate', '');
    var html = '';
    function field(name, label, type, ac, req) {
      return '<div class="hip__field" data-hip-gen><label class="hip__sr" for="' + uid + '-' + name + '">' + esc(label) + '</label>' +
        '<input class="hip__input" id="' + uid + '-' + name + '" name="contact[' + name + ']" type="' + type + '" autocomplete="' + ac + '" placeholder="' + esc(label) + '"' +
        (req ? ' required aria-required="true"' : '') + (type === 'email' ? ' inputmode="email" autocapitalize="off" autocorrect="off" spellcheck="false"' : '') + '></div>';
    }
    if (e.askFirst) html += field('first_name', t.first, 'text', 'given-name', e.firstRequired);
    if (e.askLast) html += field('last_name', t.last, 'text', 'family-name', false);
    html += field('email', t.email, 'email', 'email', true);
    html += '<button type="submit" class="hip__btn" data-hip-gen data-hip-submit>' + esc(e.buttonLabel || t.submit) + '</button>';
    f.insertAdjacentHTML('beforeend', html);
    var tags = f.querySelector('[data-hi-tags]');
    if (tags) tags.value = e.tags;
    f.removeAttribute('hidden');
    slot.appendChild(f);
  };
  App.prototype.open = function (e, step) {
    try {
      if (this.root) return;
      injectCss(this.cfg, e);
      this.hideTeaser();
      this.entry = e;
      // v1.4.0: a test link forces only the first opening of this code per visit; from now on the normal rules apply
      if (this.ctx && this.ctx.test && !(this.ctx.forced || {})[e.code]) this.sessionMap(SS_FORCED, e.code, 1);
      this.lastFocus = document.activeElement;
      var root = this.root = this.build(e);
      document.body.appendChild(root);
      this.bind(e);
      step = step || 'offer';
      if (step === 'offer' && this.needsQuestion(e) && !e.emailFirst && !this.answered) step = 'question'; // question first, email last
      this.go(step, true);
      this.startTimer(e);
    } catch (err) { this.fail(err); }
  };
  App.prototype.go = function (step, initial) {
    var root = this.root, cur = null;
    if (!root) return;
    if (step === 'question' && !root.querySelector('[data-hip-step="question"]')) step = 'success';
    Array.prototype.forEach.call(root.querySelectorAll('[data-hip-step]'), function (s) {
      var on = s.getAttribute('data-hip-step') === step; s.hidden = !on; if (on) cur = s;
    });
    this.step = step;
    var dialog = root.querySelector('.hip__dialog');
    var h = cur && cur.querySelector('.hip__headline');
    if (h && h.id) dialog.setAttribute('aria-labelledby', h.id);
    else if (h) { h.id = 'hip-h-' + step; dialog.setAttribute('aria-labelledby', h.id); }
    // on open: focus the dialog itself (screen readers announce its label; no on-screen keyboard pops up on phones)
    var focusEl = initial ? dialog : h;
    try { (focusEl || dialog).focus({ preventScroll: true }); } catch (x) { (focusEl || dialog).focus(); }
  };
  App.prototype.bind = function (e) {
    var self = this, root = this.root;
    root.addEventListener('click', function (ev) {
      var el = ev.target.closest ? ev.target.closest('[data-hip-close],[data-hip-cta],[data-hip-answer],[data-hip-skip],[data-hip-copy],[data-hip-sbtn]') : null;
      if (!el) return;
      if (el.hasAttribute('data-hip-close')) return self.close();
      // main button: close-only button = a close (days rule + teaser); a link = 'used' with the option, else a close (v1.4.0)
      if (el.hasAttribute('data-hip-cta')) { if (el.tagName !== 'A') self.close(); else self.linkClick(e, true); return; }
      if (el.hasAttribute('data-hip-answer')) return self.answer(e.answers[+el.getAttribute('data-hip-answer')], el);
      if (el.hasAttribute('data-hip-skip')) return self.answer(null, el);
      if (el.hasAttribute('data-hip-copy')) return self.copy(e.discountCode, el);
      if (el.hasAttribute('data-hip-sbtn')) { if (el.tagName !== 'A') self.close(); else { if (e.stopAfterUse) self.markUsed(e); if (el.target !== '_blank') self.teardown(); } }
    });
    this.onKey = function (ev) {
      if (!self.root) return;
      if (ev.key === 'Escape' || ev.key === 'Esc') { ev.preventDefault(); self.close(); return; }
      if (ev.key !== 'Tab') return;
      var f = Array.prototype.filter.call(self.root.querySelectorAll('a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])'), function (n) {
        return !n.disabled && n.type !== 'hidden' && !n.closest('[hidden]') && n.getAttribute('tabindex') !== '-1';
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (ev.shiftKey && (a === first || !self.root.contains(a))) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && (a === last || !self.root.contains(a))) { ev.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', this.onKey, true);
    if (!e.announcement) {
      this.onSubmit = function (ev) {
        if (self.passing) return; // our own requestSubmit(): let Shopify's captcha script and the browser handle it
        ev.preventDefault(); ev.stopPropagation(); if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        self.submit(e);
      };
      this.form.addEventListener('submit', this.onSubmit, true);
    }
  };
  App.prototype.validate = function () {
    var t = this.t, f = this.form, bad = null;
    Array.prototype.forEach.call(f.querySelectorAll('.hip__input'), function (i) {
      var v = trim(i.value), ok = true, msg = '';
      if (i.type === 'email') { ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); msg = t.errEmail; }
      else if (i.required) { ok = !!v; msg = t.errRequired; }
      i.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (!ok && !bad) bad = { el: i, msg: msg };
    });
    if (bad) { this.showError(bad.msg); bad.el.focus(); return false; }
    return true;
  };
  App.prototype.showError = function (msg) {
    var el = this.root && this.root.querySelector('[data-hip-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  };
  App.prototype.busy = function (on) {
    var b = this.form.querySelector('[data-hip-submit]');
    if (b) { b.disabled = on; b.setAttribute('aria-busy', on ? 'true' : 'false'); }
    if (this.root) {
      this.root.classList.toggle('hip--wait', on);
      Array.prototype.forEach.call(this.root.querySelectorAll('[data-hip-answer],[data-hip-skip]'), function (x) { x.disabled = on; x.removeAttribute('aria-busy'); });
    }
  };
  // ONE POST per visitor: the email step and the question step only collect; handoff() sends everything once.
  App.prototype.needsQuestion = function (e) { return !!(e && e.answers.length && !e.announcement); };
  App.prototype.submit = function (e) {
    if (this.sending || this.completed) return; // double click / Enter repeat while sending, or already signed up
    this.showError('');
    if (!this.validate()) return;
    var em = this.form.querySelector('[name="contact[email]"]');
    if (em && this.wasSent(e.code, em.value)) return this.complete(e, em.value); // same email this visit: thank-you, no POST
    this.emailReady = true;
    if (this.needsQuestion(e) && !this.answered) return this.go('question'); // 'Ask email before question': POST after answer / skip
    this.handoff(e);
  };
  // a = answer, or null for the Skip link. Held in memory; the POST happens once the email is in.
  App.prototype.answer = function (a, btn) {
    if (this.sending || this.completed || !this.entry) return;
    this.answered = true;
    this.answerSel = this.lastAnswer = a ? { tag: a.tag } : null;
    if (!this.emailReady) return this.go('offer'); // question first: now the email step
    this.handoff(this.entry);
    if (btn && this.sending) btn.setAttribute('aria-busy', 'true');
  };
  App.prototype.sentList = function (code) { var m = sGet(this.ss, SS_SENT) || {}; return m[code] || []; };
  App.prototype.wasSent = function (code, email) { return this.sentList(code).indexOf(lower(email)) !== -1; };
  // Signed up (confirmed by Shopify, or the same email again this visit): remember, thank-you screen, never POST again.
  App.prototype.complete = function (e, email) {
    this.completed = true;
    sDel(this.ss, SS_PENDING);
    this.saveState(e.code, { submitted: this.now() });
    if (e.stopAfterUse) this.markUsed(e); // v1.4.0: never again in this browser (no pop-up, no teaser)
    if (email) {
      var m = sGet(this.ss, SS_SENT) || {}, l = m[e.code] || [], k = lower(email);
      if (l.indexOf(k) === -1) l.push(k);
      m[e.code] = l.slice(-20); sSet(this.ss, SS_SENT, m);
    }
    if (this.root) { this.showError(''); this.go('success'); }
  };
  // The single sign-up: real form submit. Shopify's captcha script gets the submit event, adds its token and calls form.submit()
  // (our hook: fetch, no reload) or the browser POSTs natively (page reload fallback).
  // force = the automatic reload fallback after an unconfirmed fetch (same single sign-up, sent the proven way).
  App.prototype.handoff = function (e, force) {
    if (this.completed || (this.sending && !force)) return;
    var self = this, f = this.form, win = this.win, doc = document, waited = 0, loc = win.location, t = this.t, stage = 'final';
    var val = function (k) { var i = f.querySelector('[name="contact[' + k + ']"]'); return i ? trim(i.value) : ''; };
    if (this.wasSent(e.code, val('email'))) return this.complete(e, val('email'));
    var ans = this.answerSel, tg = f.querySelector('[data-hi-tags]');
    if (tg) tg.value = ans ? e2tags(e.tags, ans.tag) : e.tags; // newsletter, popup-<code>[, q-<answer>]
    var ret = returnPath(loc), rt = f.querySelector('input[name="return_to"]');
    if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; f.appendChild(rt); }
    rt.value = ret; // come back to this page (path + query), not the home page
    var pending = { code: e.code, stage: stage, next: 'success', email: val('email'), first_name: val('first_name'), last_name: val('last_name'),
      tag: ans ? ans.tag : '', answered: !!this.answered, ret: ret, t: this.now() };
    sSet(this.ss, SS_PENDING, pending);
    this.sending = true; this.busy(true);
    var run = this.run = {}; // this hand-off; a newer one (or done) makes the old timers no-ops
    var captcha = function () { return !!(win.Shopify && win.Shopify.captcha); };
    var bound = function () { return f.hasAttribute('data-hcaptcha-bound') || f.hasAttribute('data-recaptcha-bound'); };
    var token = function () { var x = f.querySelector('[name="h-captcha-response"],[name="g-recaptcha-response"]'); return !!(x && x.value); };
    var mark = function () { // page is leaving: the POST really started (token present or no captcha on this store)
      run.left = true;
      if (!captcha() || token()) { pending.sent = true; sSet(self.ss, SS_PENDING, pending); }
    };
    var log = function (m, x) { try { if (self.ctx && (self.ctx.test || self.ctx.designMode)) win.console.warn('[hi-popup] sign-up: ' + m, x === undefined ? '' : x); } catch (y) {} };
    function done(err, why, msg) {
      if (self.run !== run) return;
      self.run = null; captchaTap = null;
      win.removeEventListener('pagehide', mark); win.removeEventListener('pageshow', back);
      self.sending = false; self.busy(false);
      if (err) {
        sDel(self.ss, SS_PENDING);
        log('not confirmed (' + why + ')');
        if (err !== 'closed' && err !== 'retry') {
          if (self.root && self.step !== 'offer') self.go('offer'); // the message, email and button live on the email step
          self.showError(msg || (err === 'check-closed' ? t.errCheckClosed : t.errConfirm));
        }
      }
    }
    run.e = e; run.stage = stage; run.pending = pending; run.finish = done; run.log = log;
    run.markSent = function () { run.left = true; pending.sent = true; sSet(self.ss, SS_PENDING, pending); };
    // after requestSubmit: wait for hCaptcha's answer, a visible challenge, or the page leaving. Never re-enable silently.
    function watch(since) {
      if (self.run !== run || run.left || run.fetching) return; // fetch() path: ajaxSubmit() reports the result itself
      if (!self.root) return done('closed', 'pop-up closed');
      var now = Date.now(), vis = challengeVisible(doc, f);
      if (!run.token && token()) run.token = now;
      if (vis) { run.seen = true; run.hiddenAt = 0; run.since = now; } // visitor is solving the puzzle: no time limit
      else if (run.seen && !run.token) {                                // puzzle went away without an answer
        run.hiddenAt = run.hiddenAt || now;
        if (now - run.hiddenAt > 1500) return done('check-closed', 'challenge closed without an answer');
      }
      if (run.token) { if (now - run.token > self.leaveWait) return done(true, 'token added but the page did not leave'); }
      else if (!captcha()) { if (now - since > self.leaveWait) return done(true, 'page did not leave'); }
      else if (!run.started && !run.seen) { if (now - since > (run.tapped ? self.startWait : self.checkWait)) return done(true, 'hCaptcha did not start'); }
      else if (!vis && now - (run.since || since) > self.checkWait) return done(true, 'no answer from hCaptcha');
      self.later(function () { watch(since); }, POLL);
    }
    var back = function (ev) { if (ev && ev.persisted) { win.removeEventListener('pageshow', back); run.left = false; done('closed', 'back/forward cache'); } };
    function go() {
      if (self.run !== run) return;
      if (!self.root) return done('closed', 'pop-up closed');
      if (captcha() && !bound()) {
        // same as a visitor focusing a field: Shopify's script binds hCaptcha to the form on focusin
        if (!waited) { try { f.dispatchEvent(new win.FocusEvent('focusin', { bubbles: true })); } catch (x) {} }
        if (waited >= self.captchaWait) return done(true, 'hCaptcha never bound to the form');
        waited += 100; return self.later(go, 100);
      }
      run.tapped = tapHcaptcha(win);
      captchaTap = function (p) {
        if (self.run !== run) return;
        run.started = true; run.since = Date.now();
        if (p && typeof p.then === 'function') p.then(function () { if (self.run === run) { run.token = run.token || Date.now(); } }, function (er) {
          var m = str(er && (er.message || er));
          log('hCaptcha rejected', m);
          done(/close/i.test(m) ? 'check-closed' : true, 'hCaptcha: ' + m);
        });
      };
      win.addEventListener('pagehide', mark);
      win.addEventListener('pageshow', back);
      self.passing = true;
      try { self.requestSubmit(f); } catch (x) { self.passing = false; return done(true, 'requestSubmit threw'); }
      self.passing = false;
      watch(Date.now());
    }
    // a fresh task, never inside the submit event that called us (else the browser drops requestSubmit silently)
    self.later(go, 0);
  };
  // Give the form its own submit() before Shopify's script binds it (see the note above the constants). Returns true when installed.
  App.prototype.installHook = function (f) {
    var self = this;
    if (!f || f.hasAttribute('data-hcaptcha-bound') || f.hasAttribute('data-recaptcha-bound')) return false; // too late: native path
    var hook = function () {
      var form = this && this.tagName === 'FORM' ? this : f, run = self.run;
      if (form === self.form && (self.completed || (run && run.fetching))) return; // already sent / sending: never a 2nd POST
      try { if (run && !run.fetching && form === self.form && self.ajaxOn() && self.ajaxSubmit(form, run)) return; } catch (x) { try { run.log('fetch path failed, page reload instead', x); } catch (y) {} }
      self.win.HTMLFormElement.prototype.submit.call(form); // normal native POST (page reload)
    };
    hook.__hip = true;
    try { f.submit = hook; } catch (x) { return false; }
    return f.submit === hook;
  };
  App.prototype.ajaxOn = function () {
    return !!(this.ajax && this.fetch && this.win.URLSearchParams && this.win.DOMParser && !sGet(this.ss, SS_NOAJAX));
  };
  // A fresh copy of the form for the next submit: new hCaptcha widget = new token (never re-send a used one), no form_key.
  App.prototype.renewForm = function () {
    var old = this.form, nf;
    try { nf = old.cloneNode(true); } catch (x) { return; }
    Array.prototype.slice.call(nf.querySelectorAll('.h-captcha,[name="h-captcha-response"],[name="g-recaptcha-response"],[name="form_key"],[data-hi-form-ok],[data-hi-form-errors]'))
      .forEach(function (n) { n.parentNode && n.parentNode.removeChild(n); });
    ['data-hcaptcha-bound', 'data-recaptcha-bound', 'data-cptcha'].forEach(function (a) { nf.removeAttribute(a); });
    if (old.parentNode) old.parentNode.replaceChild(nf, old);
    if (this.onSubmit) { old.removeEventListener('submit', this.onSubmit, true); nf.addEventListener('submit', this.onSubmit, true); }
    this.form = nf;
    this.installHook(nf);
  };
  // Shopify's script calls this (through our hook) with h-captcha-response in the form. true = handled here, false = native POST.
  App.prototype.ajaxSubmit = function (f, run) {
    var self = this, win = this.win, ss = this.ss, t = this.t;
    var tokEl = f.querySelector('[name="h-captcha-response"]'), tok = tokEl ? str(tokEl.value) : '';
    if (!tok) return false; // no token: not Shopify's hCaptcha call -> browser POST, as before
    if (tok === this.usedToken) { this.renewForm(); run.finish(true, 'hCaptcha returned an already used token'); return true; }
    this.usedToken = tok;
    run.fetching = true; run.token = run.token || Date.now();
    var fd = new win.FormData(f), body = new win.URLSearchParams(), fkEl = f.querySelector('[name="form_key"]'), fk = fkEl ? fkEl.value : '';
    fd.forEach(function (v, k) { body.append(k, typeof v === 'string' ? v : ''); }); // urlencoded, like the native POST
    var ctrl = win.AbortController ? new win.AbortController() : null, settled = false;
    var p = run.pending, ret = p.ret, e = run.e;
    function finish(kind, why, msg, url) {
      if (settled) return; settled = true;
      if (self.run !== run) return;
      run.log('fetch: ' + kind + (why ? ' (' + why + ')' : ''));
      if (kind === 'challenge') { run.markSent(); try { self.navigate(url); } catch (x) { win.location.href = url; } return; } // same as the reload flow
      if (fk) sDel(ss, fk); // the copy Shopify's script kept for a /challenge page
      self.renewForm();
      if (kind === 'ok') {
        run.finish(null);
        self.complete(e, p.email); // the single POST is done: thank-you screen
        return;
      }
      if (kind === 'error') return run.finish('form', why, msg);
      sSet(ss, SS_NOAJAX, { t: self.now(), why: why }); // from now on this visit: page-reload sign-up
      if (kind === 'unknown') { // not provably done: send it again the proven way (native POST + reload)
        run.finish('retry', why);
        if (self.root) { self.sending = true; self.busy(true); self.later(function () { self.handoff(e, true); }, 0); } // same answer tag; no click gets in between
        return;
      }
      run.finish(true, why); // network error / timeout: result unknown -> visible message, next try uses the reload flow
    }
    this.later(function () { if (!settled && ctrl) try { ctrl.abort(); } catch (x) {} finish('timeout', 'no answer from Shopify in ' + self.fetchWait + ' ms'); }, this.fetchWait);
    var req = { method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow', headers: { Accept: 'text/html,application/xhtml+xml' } };
    if (ctrl) req.signal = ctrl.signal;
    this.fetch(f.action, req).then(function (res) {
      return res.text().then(function (html) {
        var c = classifyResponse(res, html, ret, win);
        finish(c.kind, c.why, c.msg, c.url);
      });
    }).then(null, function (er) { finish('network', 'fetch failed: ' + str(er && (er.message || er))); });
    return true;
  };
  // What Shopify answered (after redirects). Same signals as resumePending() uses after a page reload.
  function classifyResponse(res, html, ret, win) {
    var u = null; try { u = new win.URL(res.url || '', win.location.href); } catch (x) {}
    if (u && /\/challenge(\/|$)/i.test(u.pathname)) return { kind: 'challenge', url: u.href };
    if (!res.ok) return { kind: 'unknown', why: 'HTTP ' + res.status };
    var doc = null; try { doc = new win.DOMParser().parseFromString(str(html), 'text/html'); } catch (x) {}
    var errEl = doc && doc.querySelector('[data-hi-form-errors]');
    if (errEl) {
      var m = trim(errEl.getAttribute('data-hi-form-errors'));
      return TAKEN_RE.test(m) ? { kind: 'ok', why: 'already subscribed' } : { kind: 'error', why: 'form error: ' + m, msg: m };
    }
    if ((u && /(^|[?&])customer_posted=true/.test(u.search)) || (doc && doc.querySelector('[data-hi-form-ok]'))) return { kind: 'ok' };
    if (res.redirected && u && returnPath(u) === ret) return { kind: 'ok', why: 'redirected back to the return URL' };
    return { kind: 'unknown', why: 'no confirmation in the answer (' + (u ? u.pathname : '?') + ')' };
  }
  function e2tags(base, extra) { return splitList(base).concat([extra]).join(', '); }
  App.prototype.copy = function (code, btn) {
    var t = this.t, live = this.root.querySelector('[data-hip-live]');
    function done() { btn.textContent = t.copied; if (live) live.textContent = t.copied; setTimeout(function () { btn.textContent = t.copy; }, 2000); }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(code).then(done, legacy);
    } catch (x) {}
    legacy();
    function legacy() {
      try {
        var ta = document.createElement('textarea'); ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); done();
      } catch (x) {}
    }
  };
  // Writes d/h/m/s into the fixed-size boxes. 3+ digit values get a smaller digit class; the box itself never changes size.
  function paintTimer(el, p) {
    ['d', 'h', 'm', 's'].forEach(function (u) {
      var n = el.querySelector('[data-hip-' + u + ']'); if (!n) return;
      var v = Math.max(0, Math.floor(+p[u] || 0)), txt = v < 10 ? '0' + v : '' + v;
      if (n.textContent !== txt) n.textContent = txt;
      n.classList.toggle('hip__num--3', txt.length === 3);
      n.classList.toggle('hip__num--4', txt.length >= 4);
    });
  }
  App.prototype.startTimer = function (e) {
    var self = this, el = this.root.querySelector('[data-hip-timer]');
    if (!el || !e.countdownEnd) return;
    function tick() {
      if (!self.root) return clearInterval(self.tickId);
      var p = countdownParts(e.countdownEnd, self.now());
      if (p.done) {
        clearInterval(self.tickId); el.hidden = true;
        if (e.hideOnCountdownEnd) self.teardown();
        return;
      }
      paintTimer(el, p);
    }
    tick();
    this.tickId = setInterval(tick, 1000);
  };
  // v1.4.0 close (X, overlay, Esc, a close-only button, or a link click without the 'used' option):
  //  * closed time in localStorage (per code) -> the 'Show again after' days, on every page, test links included;
  //  * closed this visit in sessionStorage -> it never opens again on any page of this visit;
  //  * the teaser tab (if the pop-up has teaser text) is 'on' for the rest of the visit, EVERY time it is closed.
  // After a sign-up (this pop-up or within the sign-up days) or 'used' nothing is recorded and no teaser shows.
  App.prototype.close = function () {
    var e = this.entry;
    if (!e) return;
    var st = this.state(e.code);
    var done = this.completed || submittedRecently(e, st, this.now()) || (e.stopAfterUse && st.used);
    if (!done) {
      this.saveState(e.code, { closed: this.now() });
      this.sessionMap(SS_CLOSED, e.code, 1);
      if (e.teaserText) this.sessionMap(SS_TEASER, e.code, 'on');
    }
    this.teardown();
    if (!done && e.teaserText) this.showTeaser(e);
  };
  // main button link (announcement) or thank-you button link: with "Don't show again after sign-up or link click" = 'used'
  // (permanent, no teaser); without it = a normal close (days rule, closed this visit, teaser).
  App.prototype.linkClick = function (e) {
    if (!e.stopAfterUse) return this.close();
    this.markUsed(e);
    this.teardown();
  };
  App.prototype.markUsed = function (e) {
    var now = this.now();
    this.saveState(e.code, { used: now, closed: now });
    this.sessionMap(SS_CLOSED, e.code, 1);
    this.sessionMap(SS_TEASER, e.code, 'off');
    this.hideTeaser();
  };
  App.prototype.teardown = function () {
    if (!this.root) return;
    clearInterval(this.tickId);
    document.removeEventListener('keydown', this.onKey, true);
    if (this.onSubmit) this.form.removeEventListener('submit', this.onSubmit, true);
    // put the native form back so a later open (teaser) can reuse it
    var home = document.getElementById('hi-popup-native');
    if (home && this.form) home.appendChild(this.form);
    this.root.parentNode && this.root.parentNode.removeChild(this.root);
    this.root = null;
    try { if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true }); } catch (x) {}
  };
  App.prototype.showTeaser = function (e) {
    var self = this, t = this.t;
    if (this.teaser || !e.teaserText) return;
    injectCss(this.cfg, e);
    var el = this.teaser = document.createElement('div');
    el.className = 'hip-teaser hip-teaser--' + (e.teaserRight ? 'right' : 'left');
    el.setAttribute('style', styleVars(e));
    el.innerHTML = '<button type="button" class="hip-teaser__open" aria-haspopup="dialog">' + esc(e.teaserText) + '</button>' +
      '<button type="button" class="hip-teaser__x" aria-label="' + esc(t.hideTab) + '">&times;</button>';
    el.querySelector('.hip-teaser__open').addEventListener('click', function () { self.open(e, 'offer'); });
    // v1.4.0: closing the tab hides it for the rest of THIS visit only (sessionStorage). It never makes the pop-up eligible
    // again (closed / closed-this-visit stay as they are) and it never hides the tab after a later close.
    el.querySelector('.hip-teaser__x').addEventListener('click', function () { self.sessionMap(SS_TEASER, e.code, 'off'); self.hideTeaser(); });
    document.body.appendChild(el);
  };
  App.prototype.hideTeaser = function () { if (this.teaser) { this.teaser.parentNode && this.teaser.parentNode.removeChild(this.teaser); this.teaser = null; } };
  App.prototype.fail = function (err) {
    try { this.teardown(); } catch (x) {}
    try { this.win.console && this.win.console.warn('[hi-popup] disabled after error:', err); } catch (x) {}
  };

  /* ------------------------------------------------------------------ boot */
  function readConfig() {
    var el = document.getElementById('hi-popup-data');
    if (!el) return null;
    try { return JSON.parse(el.getAttribute('data-json') || el.textContent || '{}'); } catch (e) { return null; }
  }
  function boot(opts) {
    try {
      var cfg = readConfig();
      if (!cfg || !cfg.entries || !cfg.entries.length) return null;
      var app = new App(cfg, opts);
      app.start();
      return app;
    } catch (err) {
      try { window.console && window.console.warn('[hi-popup] not started:', err); } catch (x) {}
      return null;
    }
  }

  window.HiPopup = {
    version: VERSION,
    boot: boot,
    _t: { parseRules: parseRules, pageRules: pageRules, evalRules: evalRules, matchRule: matchRule, normalize: normalize, evaluate: evaluate,
      selectEntry: selectEntry, testState: testState, torontoToUtc: torontoToUtc, tzOffset: tzOffset, easternOffsetManual: easternOffsetManual,
      parseTime: parseTime, countdownParts: countdownParts, returnPath: returnPath, slugify: slugify, strings: strings, App: App, collectParams: collectParams, localizeLink: localizeLink, classifyResponse: classifyResponse, paintTimer: paintTimer, styleVars: styleVars, CSS: CSS, GAP: GAP, CD_GAP_RATIO: CD_GAP_RATIO, SMALL_PRINT_SEL: SMALL_PRINT_SEL, frequencyBlocked: frequencyBlocked, SS: { CLOSED: SS_CLOSED, TEASER: SS_TEASER, FORCED: SS_FORCED, TEST: SS_TEST } }
  };
  // Loaded async right after its own markup: boot as soon as the data, the form and <body> exist, without waiting for
  // DOMContentLoaded, window load or other scripts. Only if the markup is not there yet (unusual install) wait for DCL.
  if (!window.HiPopupNoAutoBoot) {
    var ready = document.readyState !== 'loading' || (document.body && document.getElementById('hi-popup-data') && document.getElementById('HiPopupForm'));
    if (ready) window.HiPopup.app = boot();
    else document.addEventListener('DOMContentLoaded', function () { window.HiPopup.app = boot(); });
  }
})(window, document);